var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTokenPrice(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.25 10C19.25 4.89137 15.1086 0.75 10 0.75C4.89137 0.75 0.75 4.89137 0.75 10C0.75 15.1086 4.89137 19.25 10 19.25C15.1086 19.25 19.25 15.1086 19.25 10Z",
    stroke: "#D80587",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.77069 8.12871L11.4962 7.24364C12.2731 6.99132 13.0085 7.72663 12.7561 8.50361L11.8711 11.229C11.7722 11.5336 11.5334 11.7724 11.2288 11.8713L8.50339 12.7564C7.72639 13.0087 6.99107 12.2734 7.2434 11.4964L8.12849 8.77091C8.22739 8.46641 8.46619 8.22761 8.77069 8.12871Z",
    stroke: "#D80587",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTokenPrice);
export default __webpack_public_path__ + "static/media/token-price.405b44cb2db7256bdf890ea964cdb942.svg";
export { ForwardRef as ReactComponent };